class CardProductVariants extends HTMLElement {
  connectedCallback() {
    this.variants = this.readJson('[data-card-product-variants]');
    this.optionNames = this.readJson('[data-card-product-options]');
    this.form = this.closest('form');
    this.input = this.form?.querySelector('[name="id"]');
    this.submitButton = this.form?.querySelector('[type="submit"]');
    this.submitLabel = this.submitButton?.querySelector('[data-add-to-cart-text]');
    this.soldOutLabel = this.submitButton?.querySelector('.sold-out-message');
    this.cardLink =
      this.closest('.card-wrapper')?.querySelector('.card__heading a') ||
      this.closest('.card')?.querySelector('.card__heading a');
    this.productUrl = this.dataset.productUrl;
    this.selected = {};

    if (!this.variants.length) return;

    this.valueButtons = Array.from(this.querySelectorAll('[data-option-value]'));
    this.valueButtons.forEach((button) => {
      button.addEventListener('click', this.onValueClick.bind(this, button));
    });

    const defaultVariant = this.variants.find((variant) => variant.available) || this.variants[0];
    if (defaultVariant) {
      this.applyVariant(defaultVariant, false);
    }

    this.syncActiveStates();
    this.syncAvailability();
  }

  readJson(selector) {
    const node = this.querySelector(selector);
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return [];
    }
  }

  onValueClick(button) {
    if (button.classList.contains('is-unavailable')) return;

    this.selected[button.dataset.optionName] = button.dataset.optionValue;

    const matchedVariant = this.findVariant();
    if (matchedVariant) {
      this.applyVariant(matchedVariant, true);
    }

    this.syncActiveStates();
    this.syncAvailability();
  }

  findVariant() {
    return this.variants.find((variant) =>
      this.optionNames.every((name, index) => this.selected[name] === variant[`option${index + 1}`])
    );
  }

  applyVariant(variant, fromUserSelection) {
    this.optionNames.forEach((name, index) => {
      this.selected[name] = variant[`option${index + 1}`];
    });

    if (this.input) {
      this.input.value = variant.id;
      this.input.disabled = !variant.available;
    }

    if (this.submitButton) {
      this.submitButton.disabled = !variant.available;

      if (this.submitLabel) {
        const defaultText = this.submitLabel.dataset.defaultText || 'Add to cart';
        this.submitLabel.textContent = variant.available
          ? defaultText
          : this.soldOutLabel?.textContent?.trim() || 'Sold out';
      }
    }

    if (this.cardLink && this.productUrl) {
      const joiner = this.productUrl.includes('?') ? '&' : '?';
      this.cardLink.href = `${this.productUrl}${joiner}variant=${variant.id}`;
    }

    if (fromUserSelection) {
      this.dispatchEvent(
        new CustomEvent('card-variant:change', {
          bubbles: true,
          detail: { variant },
        })
      );
    }
  }

  syncActiveStates() {
    this.valueButtons.forEach((button) => {
      const isActive = this.selected[button.dataset.optionName] === button.dataset.optionValue;
      button.classList.toggle('is-active', isActive);
    });
  }

  syncAvailability() {
    this.valueButtons.forEach((button) => {
      const optionName = button.dataset.optionName;
      const optionValue = button.dataset.optionValue;
      const optionPosition = Number(button.dataset.optionPosition);

      const isAvailable = this.variants.some((variant) => {
        if (!variant.available) return false;
        if (variant[`option${optionPosition}`] !== optionValue) return false;

        return this.optionNames.every((name, index) => {
          const position = index + 1;
          if (name === optionName) return true;
          if (!this.selected[name]) return true;
          return variant[`option${position}`] === this.selected[name];
        });
      });

      button.classList.toggle('is-unavailable', !isAvailable);
      if (isAvailable) {
        button.removeAttribute('aria-disabled');
      } else {
        button.setAttribute('aria-disabled', 'true');
      }
    });
  }
}

customElements.define('card-product-variants', CardProductVariants);
